import React from 'react';
import LinksFooter, {
  LinksFooterProps,
} from '../../../../../../components/App/footer/LinksFooter/LinksFooter';
import { useMediaQuery, useTheme } from '@mui/material';
import logo_footer from '../../../../assets/Fringand_White.svg';
import { getPolyglot } from '../../../../../../i18n';

function LinksFooterFF(props: LinksFooterProps) {
  const theme = useTheme();
  const polyglot = getPolyglot();

  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const {
    logoFooter = logo_footer,
    predefinedLinks = {
      [polyglot.t('footer.impressum')]: {
        label: polyglot.t('footer.impressum'),
        to: 'https://www.foursfringand.com/fr/mentions-legales/',
        external: true,
      },
      [polyglot.t('footer.terms_and_conditions')]: {
        label: polyglot.t('footer.terms_and_conditions'),
        to: '',
        external: false,
      },
      [polyglot.t('footer.cookie_policy')]: {
        label: polyglot.t('footer.cookie_policy'),
        to: '/',
        external: false,
      },
    },
  } = props;
  return (
    <LinksFooter
      logoFooter={logoFooter}
      logoHeight={isTablet ? 20 : 30}
      predefinedLinks={predefinedLinks}
    />
  );
}

export default LinksFooterFF;
